import { query } from '@/utils/request';

// 托收明细分页查询
export async function getCollectionDetailsList(data) {
  return query('/zlb/api/pay/tuoshou/page', {
    data,
    method: 'POST',
  });
}

// 明细导出
export async function exportCollectionDetails(data) {
  return query('/zlb/api/pay/tuoshou/export', {
    data,
    method: 'POST',
  });
}

// 获取导出结果
export async function getDetailsExportResult(params) {
  return query('/zlb/api/pay/tuoshou/export/result', {
    params,
  });
}

// 托收明细最后同步时间
export async function getLastSyncTime() {
  return query('/zlb/api/pay/tuoshou/lastSyncTime');
}

// 同步托收明细
export async function syncCollectionDetails(data) {
  return query('/zlb/api/pay/tuoshou/sync', {
    data,
    method: 'POST',
  });
}

export async function getAccountList() {
  return query('/zlb/api/pay/tuoshou/account');
}

// 标记为托收/非托收
export async function handleCancelMark(data) {
  return query('/zlb/api/pay/tuoshou/mark', {
    data,
    method: 'POST',
  });
}
